import styled from '@emotion/styled';
import Gap from '~/components/Gap';
import StyledInput from '~/components/StyledInput';
import Text from '~/components/Text';
import Toggle from '~/components/Toggle';
import { fmPrice } from '~/utils/amount';
import { getTotalAmountDetails } from '../EstimateForm/helpers';
import OptionSelector from '../EstimateForm/OptionSelector';
import { IBaseSectionType } from '../EstimateForm/types';

const Wrapper = styled.div`
  padding: 16px 16px 24px 16px;
`;

const SubTotal = styled.div`
  margin-bottom: 16px;
`;

const ExtraWrapper = styled.div`
  border-top: 1px solid var(--border1);
  border-bottom: 1px solid var(--border1);
  padding: 16px 0;

  .extraInput {
    max-width: 100px;
  }
`;

const GrandTotal = styled.div`
  margin-top: 24px;
`;

const SummarySectionPhone = ({ formData, setValue }: IBaseSectionType) => {
  const { subTotal, discount, tax, shipping, totalAmount } = getTotalAmountDetails(formData);
  const { currency } = formData;

  return (
    <Wrapper>
      <Text size="ssmd">Summary</Text>
      <Gap t={16} />

      <SubTotal className="spread">
        <Text>Sub Total</Text>
        <Text>{fmPrice(currency, subTotal)}</Text>
      </SubTotal>

      <ExtraWrapper>
        <div className="spread">
          <div>
            <Text size="xs" id="discountLabelPhone">
              Discount
            </Text>
            <Gap t={4} />
            <div className="full-width align-center">
              <StyledInput
                aria-labelledby="discountLabelPhone"
                className="full-flex extraInput attachedInput"
                value={formData.discount}
                onChange={(event: any) => {
                  setValue({
                    discount: event.target.value,
                  });
                }}
              />

              <OptionSelector
                value={formData.discountType}
                onChange={newVal => {
                  setValue({
                    discountType: newVal,
                  });
                }}
              />
            </div>
          </div>

          <Text>{fmPrice(currency, discount)}</Text>
        </div>

        <Gap t={16} />

        <div className="spread">
          <div>
            <Text size="xs" id="taxLabelPhone">
              Tax
            </Text>
            <Gap t={4} />
            <div className="full-width align-center">
              <StyledInput
                aria-labelledby="taxLabelPhone"
                className="full-flex extraInput attachedInput"
                value={formData.tax}
                onChange={(event: any) => {
                  setValue({
                    tax: event.target.value,
                  });
                }}
              />

              <OptionSelector
                value={formData.taxType}
                onChange={newVal => {
                  setValue({
                    taxType: newVal,
                  });
                }}
              />
            </div>
          </div>

          <Text>{fmPrice(currency, tax)}</Text>
        </div>

        <Gap t={16} />

        <div className="spread">
          <div>
            <Text size="xs" id="shippingLabelPhone">
              Shipping
            </Text>
            <Gap t={4} />
            <div className="full-width align-center">
              <StyledInput
                aria-labelledby="shippingLabelPhone"
                className="full-flex extraInput attachedInput"
                value={formData.shipping}
                onChange={(event: any) => {
                  setValue({
                    shipping: event.target.value,
                  });
                }}
              />

              <OptionSelector
                value={formData.shippingType}
                onChange={newVal => {
                  setValue({
                    shippingType: newVal,
                  });
                }}
              />
            </div>
          </div>

          <Text>{fmPrice(currency, shipping)}</Text>
        </div>

        <Gap t={16} />

        <div className="spread">
          <Text size="xs">Show shipping address in Estimate</Text>
          <Gap t={8} />
          <Toggle
            checked={formData.isShippingEnabled}
            onChange={checked => {
              setValue({
                isShippingEnabled: checked,
              });
            }}
            label={''}
          />
        </div>
      </ExtraWrapper>

      <GrandTotal className="spread">
        <Text size="ssmd" variant="success" className="bold">
          TOTAL AMOUNT
        </Text>
        <Text size="ssmd" variant="success" className="bold">
          {fmPrice(currency, totalAmount)}
        </Text>
      </GrandTotal>
    </Wrapper>
  );
};

export default SummarySectionPhone;
